import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PaginationPageButton } from './PaginationPageButton';
export const PaginationPageButtons = ({ onPageButtonClick, pagination }) => {
    return (_jsx(_Fragment, { children: Array.from({ length: pagination.pagesAmount }, (_, i) => i + 1).map((page) => (_jsx(PaginationPageButton, { onPageButtonClick: onPageButtonClick, page: page, pagination: pagination }, page))) }));
};
